import { compose } from 'recompose';

import CatalogDetails from './CatalogDetails';
import apiInterceptor from '../../../../../api/interceptor';
import { buApi, skuDetailsApi } from '../../../../common/base.api';

const composedCatalogDetails = compose(apiInterceptor({ ...skuDetailsApi, getBUList: buApi.getList }))(CatalogDetails);

export default composedCatalogDetails;
